import React from 'react';
import { CheckCircleIcon, BookOpenIcon } from 'lucide-react';
export function CourseDescription() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1494">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1495">
        <div className="mb-12" data-id="element-1496">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1497">
            About the Course
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1498">
            <p className="text-base text-gray-800 mb-6 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1499">
              NRA FIRST Steps Pistol is designed to provide a hands-on
              introduction to the safe handling and proper orientation to one
              specific pistol action type for classes of four or fewer students.
              This course is at least three hours long and includes classroom
              and range time learning to shoot a specific pistol action type.
            </p>
            <h3 className="text-lg font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1500">
              What You'll Learn
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-1501">
              {["NRA's rules for safe gun handling", 'Pistol model parts and operation', 'Ammunition fundamentals', 'Shooting fundamentals', 'Cleaning the pistol', 'Continued skill development opportunities'].map(topic => <div key={topic} className="flex items-start gap-3" data-id="element-1502">
                  <CheckCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#1e3d2f'
              }} data-id="element-1503" />
                  <span className="text-sm text-gray-800" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1504">
                    {topic}
                  </span>
                </div>)}
            </div>

            <h3 className="text-lg font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1505">
              Students Will Receive
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1506">
              {['Basics of Pistol Shooting handbook', 'NRA Gun Safety Rules brochure', 'NRA Marksmanship Qualification booklet', 'FIRST Steps Course completion certificate'].map(item => <div key={item} className="flex items-start gap-3" data-id="element-1507">
                  <BookOpenIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#c8a84b'
              }} data-id="element-1508" />
                  <span className="text-sm text-gray-800" style={{
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1509">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}